module.exports = __webpack_public_path__ + "img/publicAccount.b59ab920.jpg";